import { Routes, Route } from 'react-router';
import { RequireAuth } from './RequireAuth';
import { RequireTenant } from './RequireTenant';
import { LoginPage } from '../pages/LoginPage';
import { HomePage } from '../pages/HomePage';
import { CallbackPage } from '../pages/CallbackPage';
import { WorkspacePlaceholder } from '../pages/WorkspacePlaceholder';
import { NotFoundPage } from '../pages/NotFoundPage';

/**
 * AppRouter — the S-E3 route table. Public: /login, /callback, * (404).
 * Protected (compose RequireAuth → RequireTenant): / and /workspace/*.
 * The real home and the workspace tree arrive in later stories (F1 / §5.2);
 * E3 ships placeholders behind the guards.
 */
export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/callback" element={<CallbackPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <RequireTenant>
              <HomePage />
            </RequireTenant>
          </RequireAuth>
        }
      />
      <Route
        path="/workspace/*"
        element={
          <RequireAuth>
            <RequireTenant>
              <WorkspacePlaceholder />
            </RequireTenant>
          </RequireAuth>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
AppRouter.displayName = 'AppRouter';
